// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { PushNotifications } from '@capacitor/push-notifications';
import { isPlatform } from '@ionic/react';
import {jwtDecode} from 'jwt-decode';
import axiosInstance from './api/axiosInstance';

const firebaseConfig = {
  apiKey: "AIzaSyCUvvCwAnsAyc_SCQ8x_aOppnyBZ7qsxTg",
  authDomain: "trippin-a858e.firebaseapp.com",
  projectId: "trippin-a858e",
  storageBucket: "trippin-a858e.firebasestorage.app",
  messagingSenderId: "149487737670",
  appId: "1:149487737670:web:7c642ce5edfeaa41402347",
  measurementId: "G-789PPVJ0PC"
};

export const initializePushNotifications = async (accessToken) => {


  if (!accessToken) {
      console.error('No access token found. Skipping push notifications.');
      return;
  }

  try {
      const decodedToken = jwtDecode(accessToken);
      const userId = decodedToken.user_id;

      if (!userId) {
          console.error('User ID not found in token. Skipping push notifications.');
          return;
      }

      if (isPlatform('hybrid')) {
          console.log('Initializing mobile push notifications...');
          
          // Ensure permissions are explicitly requested
          let permission = await PushNotifications.checkPermissions();
          if (permission.receive !== 'granted') {
              console.log('Requesting push notification permissions...');
              permission = await PushNotifications.requestPermissions();
              if (permission.receive !== 'granted') {
                  console.warn('Push notifications permission not granted.');
                  return;
              }
          }

          // Register for push notifications
          await PushNotifications.register();

          // Handle registration success
          PushNotifications.addListener('registration', async (token) => {
              console.log('Push registration success:', token.value);

              // Save the FCM token to the backend
              await fetch('https://api.trippin.icu/api/device-tokens', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${accessToken}`,
                  },
                  body: JSON.stringify({ deviceToken: token.value }),
              }).then(response => response.json())
                .then(data => console.log("Token stored successfully:", data))
                .catch(error => console.error("Error saving token:", error));
          });

          // Handle registration errors
          PushNotifications.addListener('registrationError', (error) => {
              console.error('Push registration error:', error);
          });

          // Listen for push notifications
          PushNotifications.addListener('pushNotificationReceived', (notification) => {
              console.log('Push notification received:', notification);
          });

          PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
              console.log('Push notification action performed:', notification);
              const data = notification.notification.data;

              if (data.route) {
                window.location.href = data.route;
              }
          });

      } else {
          console.log('PushNotifications plugin is not available on web.');
          handleForegroundNotifications();
      }
  } catch (error) {
      console.error('Error initializing push notifications:', error);
  }
};


  const handleForegroundNotifications = () => {
    onMessage(messaging, (payload) => {
      console.log("🔔 Foreground notification received:", payload);
      const { title, body, icon } = payload.notification || payload.data || {};
      if (!title || !body) {
        console.warn("Missing title/body in payload. Adjust your backend message or handler.");
        return;
      }
      if (Notification.permission === "granted") {
        new Notification(title, {
          body,
          icon: icon || "/default-icon.png",
        });
      } else {
        console.warn("⚠️ Notifications blocked or permission not granted.");
      }
    });    
  };

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: 'BNbQtftms3KUacZqS-9PghWZaFXpZcr03Sph4Q08Eih3EE-YE8evg1gS92LNffb9NWaEUNkwT8z4T_cMwbGzP0Q',
      });

      console.log('FCM Token:', token);

      // Save the token using axiosInstance (auth headers and CSRF handled automatically)
      await axiosInstance.post('/device-tokens', {
        deviceToken: token,
      });
    } else {
      console.log('Notification permission denied');
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
  }
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
let messaging;
try {
   messaging = getMessaging(app);
} catch (err) {
  console.error("error, but ok (iOS)", err);
}

export { messaging, getToken, onMessage };
